import { useMutation } from '@tanstack/react-query';

import type { JobFormValues } from 'shared/legacy/contexts/DialogContext/modals/EnrichVacancyModal/components/EditEnrichedVacancyForm/EditEnrichedVacancy.types';

import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { useGTM } from 'hooks/gtm';
import { mapJobFormValuesToJobImprovedNestedInput } from 'shared/legacy/contexts/DialogContext/modals/EnrichVacancyModal/utils/EnrichVacancyModal.mappers';
import { QueryKey } from 'types/query';

export const useGenerateJobPreviewMutation = () => {
  const gtm = useGTM();

  return useMutation({
    mutationKey: [QueryKey.useGenerateJobPreviewMutation],
    mutationFn: async (formData: JobFormValues) => {
      const nestedValues = mapJobFormValuesToJobImprovedNestedInput(formData);
      const response = await reachoutClient.generateJobPreview(nestedValues);

      return response.data.job_preview;
    },
    onSuccess: () => {
      gtm.jobPreviewGenerated();
    },
  });
};
